import React, { useState, useEffect, useContext } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { API_URL } from "../../components/api";
import { formatDateTime } from "../../../utils/dateFormat";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarExport,
  GridFooterContainer,
  GridFooter,
  GridPagination,
} from "@mui/x-data-grid";
import AuthContext from "../../context/AuthContext";
import Typography from "@mui/material/Typography";
import ExcelSVG from "./ExcelSVG.svg";
import FilterSVG from "./FilterSVG.svg";
import * as XLSX from "xlsx";

// For API Requests
import axios from "axios";

function ReceiptTable(props) {
  const [data, setData] = useState([]);
  const [show, setShow] = useState(false);

  const [showo, setShowo] = useState(false);
  const [dashoo, setDasho] = useState(false);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedReceiptId, setSelectedReceiptId] = useState(null);

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);
  console.log(props.client_id);
  const { user } = useContext(AuthContext);
  let authTokens = JSON.parse(localStorage.getItem("authTokens"));

  const [ClientDetails, setClientDetails] = useState({
    client_id: 0,
    receipt_id: 0,
    paid_amount_usd: 0,
    paid_amount_lbp: 0,
    exchange_rate: "",
    discount_lbp: "",
    returned_lbp: "",
    fullname_en: "",
  });

  const [filters, setFilters] = useState({
    fullname_en: "",
    paid_amount_usd: "",
    paid_amount_lbp: "",
    exchange_rate: "",
    balance_record: "",
    discount_usd: "",
    discount_lbp: "",
    returned_lbp: "",
    initiator: "",
    date: "",
  });
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [gridFilterModel, setGridFilterModel] = useState({
    items: [],
  });

  const [searchInput, setSearchInput] = useState(""); // To capture search input

  // NEW: State to track column visibility
  const [columnVisibilityModel, setColumnVisibilityModel] = useState({});
  const [searchFilterTimeout, setSearchFilterTimeout] = useState(null);

  const updateClientDetails = (details) => {
    setClientDetails(details);
  };
  const fetchData = async () => {
    try {
      const authTokens = JSON.parse(localStorage.getItem("authTokens"));
      const response = await axios.get(`${API_URL}/accounting/info/receipts/`, {
        headers: {
          Authorization: `Bearer ${authTokens.access}`,
        },
        params: {
          username: user.username,
          client_id: props.client_id,
        },
      });

      if (response.status === 200) {
        setData(response.data.reverse());
        console.log(response.data);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, [user.username]);

  const columns = [
    { field: "fullname_en", headerName: "Name", flex: 2, minWidth: 200 },
    {
      field: "paid_amount_usd",
      headerName: "Paid USD",
      flex: 2,
      minWidth: 100,
    },
    {
      field: "paid_amount_lbp",
      headerName: "Paid LBP",
      flex: 2,
      minWidth: 100,
    },
    { field: "exchange_rate", headerName: "Rate", flex: 2, minWidth: 100 },
    {
      field: "balance_record",
      headerName: "Balance Record",
      flex: 2,
      minWidth: 120,
    },
    {
      field: "discount_usd",
      headerName: "Discount USD",
      flex: 2,
      minWidth: 100,
    },
    {
      field: "discount_lbp",
      headerName: "Discount LBP",
      flex: 2,
      minWidth: 100,
    },
    {
      field: "returned_lbp",
      headerName: "Returned LBP",
      flex: 2,
      minWidth: 100,
    },
    { field: "initiator", headerName: "Cashier", flex: 2, minWidth: 100 },
    {
      field: "date",
      headerName: "Date",
      minWidth: 200,
      sortable: true,
      sort: "asc",
      valueFormatter: (params) => {
        const date = new Date(params.value);
        date.setHours(date.getHours() + 2);
        return formatDateTime(date);
      },
    },
  ];

  const getRowId = (row) => row.receipt_id;

  const delaySearchFilter = (input) => {
    setSearchQuery(input);
  };

  useEffect(() => {
    // Save "searchValue" value before clearing other session storage items
    const searchValue = sessionStorage.getItem("searchReceiptReport");

    // Clear all session storage items except "searchValue"
    Object.keys(sessionStorage).forEach((key) => {
      if (key !== "searchReceiptReport") {
        sessionStorage.removeItem(key);
      }
    });

    // Restore "searchValue" value if needed
    if (searchValue) {
      sessionStorage.setItem("searchReceiptReport", searchValue);
      setSearchQuery(searchValue);
    }
  }, []);

  const handleSearchChange = (event) => {
    const query = event.target.value;
    setSearchInput(query);
    sessionStorage.setItem("searchReceiptReport", query);

    if (searchFilterTimeout) {
      clearTimeout(searchFilterTimeout);
    }

    const newTimeout = setTimeout(() => {
      delaySearchFilter(query);
    }, 100);
    setSearchFilterTimeout(newTimeout);
  };

  const handleOpenModal = (receiptId) => {
    setSelectedReceiptId(receiptId);
    setShowo(true);
  };

  const handleCloseModal = () => {
    setShowo(false);
    setSelectedReceiptId(null);
  };
  const handleOpenModalRefund = (receiptId) => {
    setSelectedReceiptId(receiptId);
    setDasho(true);
  };

  const handleCloseModalRefund = () => {
    setDasho(false);
    setSelectedReceiptId(null);
  };
  const handleConfirm = async () => {
    try {
      const response = await axios.post(
        `${API_URL}/inventory/receipt/cancel/`,
        { receipt_id: selectedReceiptId, username: user.username },
        {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
          },
        }
      );

      if (response.status === 200) {
        // Optionally, refresh the data or update the state to reflect the changes
        console.log("Receipt confirmed:", response.data);
      }
    } catch (error) {
      console.error("Error confirming receipt:", error);
      window.alert(
        error.response?.data?.message ||
          "Unable to cancel the receipt."
      );
    } finally {
      handleCloseModal();
      fetchData();
    }
  };
  const handleConfirmRefund = async () => {
    try {
      const response = await axios.post(
        `${API_URL}/inventory/receipt/refund/`,
        { receipt_id: selectedReceiptId, username: user.username },
        {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
          },
        }
      );

      if (response.status === 200) {
        // Optionally, refresh the data or update the state to reflect the changes
        console.log("Receipt:", response.data);
      }
    } catch (error) {
      console.error("Error confirming receipt:", error);
    } finally {
      handleCloseModalRefund();
      fetchData();
    }
  };

  // IMPROVED: Combined filtering logic that works for both display AND export
  const filteredRows = data.filter((row) => {
    // Apply search query filter
    const searchMatch = searchQuery
      .split(" ")
      .every((word) =>
        Object.values(row).some((value) =>
          String(value).toLowerCase().includes(word.toLowerCase().trim())
        )
      );

    // Apply modal filters
    const modalFilterMatch = Object.keys(filters).every((key) => {
      if (!filters[key]) return true;

      const rowValue = String(row[key] || "").toLowerCase();
      const filterValue = String(filters[key]).toLowerCase();
      return rowValue.includes(filterValue);
    });

    // Apply DataGrid filters
    const gridFilterMatch = gridFilterModel.items.every((filterItem) => {
      if (!filterItem.value) return true;

      const cellValue = row[filterItem.field];
      const filterValue = filterItem.value;

      switch (filterItem.operator) {
        case "contains":
          return String(cellValue || "")
            .toLowerCase()
            .includes(String(filterValue).toLowerCase());
        case "equals":
          return String(cellValue || "") === String(filterValue);
        case "startsWith":
          return String(cellValue || "")
            .toLowerCase()
            .startsWith(String(filterValue).toLowerCase());
        case "endsWith":
          return String(cellValue || "")
            .toLowerCase()
            .endsWith(String(filterValue).toLowerCase());
        default:
          return true;
      }
    });

    return searchMatch && modalFilterMatch && gridFilterMatch;
  });

  const handleFilterChange = (field, value) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [field]: value,
    }));
  };

  // Define the column headers mapping
  const columnHeaders = {
    fullname_en: "Full Name",
    paid_amount_usd: "Paid Amount (USD)",
    paid_amount_lbp: "Paid Amount (LBP)",
    exchange_rate: "Exchange Rate",
    balance_record: "Balance Record",
    discount_usd: "Discount (USD)",
    discount_lbp: "Discount (LBP)",
    returned_lbp: "Returned (LBP)",
    initiator: "Initiator",
    date: "Date",
  };

  // Format date fields properly for export — e.g. "21/02/2025 10:25:52 AM"
  const formatDateForExport = (dateValue) => {
    if (!dateValue) return "";
    const date = new Date(dateValue);

    // Format as DD/MM/YYYY HH:MM:SS AM/PM
    const formattedDate = date.toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });

    // Ensure consistent spacing before AM/PM
    return formattedDate.replace(" am", " AM").replace(" pm", " PM");
  };

  // IMPROVED: Transform rows respecting column visibility
  const transformRowsForExport = (rows) => {
    return rows.map((row) => {
      const transformedRow = {};

      Object.keys(columnHeaders).forEach((field) => {
        // Check if column is visible (if not in columnVisibilityModel or explicitly true)
        const isVisible = columnVisibilityModel[field] !== false;

        if (isVisible) {
          const headerName = columnHeaders[field];

          // Handle special fields with computed values
          if (
            field === "payment_date" ||
            field === "expiration_date" ||
            field === "creation_date" ||
            field === "date"
          ) {
            transformedRow[headerName] = formatDateForExport(row[field]);
          } else {
            transformedRow[headerName] = row[field] || "";
          }
        }
      });

      return transformedRow;
    });
  };

  // IMPROVED: Export function that uses the already-filtered rows
  const handleExportToExcel = () => {
    console.log("Exporting data...");
    console.log("Total data rows:", data.length);
    console.log("Filtered rows:", filteredRows.length);
    console.log("Active filters:", {
      search: searchQuery,
      modalFilters: filters,
      gridFilters: gridFilterModel.items,
    });
    console.log("Column visibility:", columnVisibilityModel);

    // Always use filteredRows which has ALL filters applied
    const transformedRows = transformRowsForExport(filteredRows);

    console.log("Rows to export:", transformedRows.length);

    const worksheet = XLSX.utils.json_to_sheet(transformedRows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "ReceiptReport");
    XLSX.writeFile(workbook, "ReceiptReport.xlsx");
  };
  const [isPressed, setIsPressed] = useState(false);

  const handleExportClick = () => {
    setIsPressed(true);
    handleExportToExcel();
    setTimeout(() => {
      setIsPressed(false);
    }, 200);
  };

  const sumField = (field) => {
    return filteredRows.reduce((total, row) => {
      const value = parseFloat(row[field]);
      return isNaN(value) ? total : total + value;
    }, 0);
  };

  const sumPaidUsd = sumField("paid_amount_usd");
  const sumPaidLbp = sumField("paid_amount_lbp");
  const sumReturnedUsd = sumField("returned_usd");
  const sumReturnedLbp = sumField("returned_lbp");

  const CustomToolbar = () => (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <Button
        onClick={() => setShowFilterModal(true)}
        variant="outline-primary"
        style={{
          border: "none",
        }}
      >
        <img
          src={FilterSVG}
          alt="Filter Icon"
          style={{
            color: "white",
            width: "18px",
            marginRight: "8px",
            filter: "invert(0)", // keep black icon
          }}
        />
        Filter
      </Button>
      {/*<GridToolbarFilterButton />*/}
      <GridToolbarExport />
      <Button
        onClick={handleExportClick}
        variant="outline-success"
        style={{
          display: "flex",
          alignItems: "center",
          padding: "5px 10px",
          fontSize: "14px",
          border: "none",
          backgroundColor: isPressed ? "white" : "transparent",
          color: isPressed ? "black" : "#007bff",
          cursor: "pointer",
        }}
      >
        <img
          src={ExcelSVG}
          alt="Excel Icon"
          style={{
            width: "20px",
            marginRight: "8px",
            filter: isPressed ? "invert(0)" : "invert(1)",
          }}
        />
        Excel
      </Button>
    </GridToolbarContainer>
  );

  const CustomFooter = () => (
    <GridFooterContainer>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          padding: "10px",
          color: "white",
        }}
      >
        <div>Paid USD: {sumPaidUsd.toFixed(2)}</div>
        <div>Paid LBP: {sumPaidLbp.toFixed(2)}</div>
        <div>Returned USD: {sumReturnedUsd.toFixed(2)}</div>
        <div>Returned LBP: {sumReturnedLbp.toFixed(2)}</div>
        <GridPagination />
      </div>
    </GridFooterContainer>
  );

  return (
    <div className="ClientTable">
      <style>{`
        .MuiDataGrid-panelWrapper {
          background: #122632 !important;
        }
      `}</style>
      <input
        type="text"
        placeholder="Search..."
        value={searchInput}
        onChange={handleSearchChange}
        className="search-client"
      />
      {!loading && data.length > 0 && (
        <div style={{ height: 520, width: "100%" }}>
          <DataGrid
            rows={filteredRows}
            columns={columns}
            getRowId={getRowId}
            filterModel={gridFilterModel}
            onFilterModelChange={(newModel) => setGridFilterModel(newModel)}
            columnVisibilityModel={columnVisibilityModel}
            onColumnVisibilityModelChange={(newModel) =>
              setColumnVisibilityModel(newModel)
            }
            components={{
              Toolbar: CustomToolbar,
              Footer: CustomFooter,
            }}
            rowsPerPageOptions={[10, 100, 1000]}
            pagination
            disableSelectionOnClick
          />
        </div>
      )}
      <Modal show={showo} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Cancel Receipt</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to cancel this receipt?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleConfirm}>
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={dashoo} onHide={handleCloseModalRefund}>
        <Modal.Header closeButton>
          <Modal.Title>Refund Receipt</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to refund this receipt?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModalRefund}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleConfirmRefund}>
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showFilterModal} onHide={() => setShowFilterModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Filters</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {Object.keys(columnHeaders).map((field) => (
            <div key={field} className="filter">
              <label>{columnHeaders[field]}</label>
              <input
                type="text"
                placeholder={`Filter by ${columnHeaders[field]}`}
                value={filters[field] || ""}
                onChange={(e) => handleFilterChange(field, e.target.value)}
                className="filter-input"
              />
            </div>
          ))}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowFilterModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default ReceiptTable;
